<template>
  <div v-if="showSnackbars" class="snackbar-provider">
    <transition-group name="fade-snackbar" tag="article" class="top-center">
      <NSnackbar v-for="snackbarProps in topCenter" :key="snackbarProps.id" class="nsnackbar" v-bind="snackbarProps" />
    </transition-group>

    <transition-group name="fade-snackbar" tag="article" class="top-right">
      <NSnackbar v-for="snackbarProps in topRight" :key="snackbarProps.id" class="nsnackbar" v-bind="snackbarProps" />
    </transition-group>

    <transition-group name="fade-snackbar" tag="article" class="top-left">
      <NSnackbar v-for="snackbarProps in topLeft" :key="snackbarProps.id" class="nsnackbar" v-bind="snackbarProps" />
    </transition-group>

    <transition-group name="fade-snackbar" tag="article" class="bottom-center" data-scroll-chrome="bottom">
      <NSnackbar
        v-for="snackbarProps in bottomCenter"
        :key="snackbarProps.id"
        class="nsnackbar"
        v-bind="snackbarProps"
      />
    </transition-group>

    <transition-group name="fade-snackbar" tag="article" class="bottom-right">
      <NSnackbar
        v-for="snackbarProps in bottomRight"
        :key="snackbarProps.id"
        class="nsnackbar"
        v-bind="snackbarProps"
      />
    </transition-group>

    <transition-group name="fade-snackbar" tag="article" class="bottom-left">
      <NSnackbar v-for="snackbarProps in bottomLeft" :key="snackbarProps.id" class="nsnackbar" v-bind="snackbarProps" />
    </transition-group>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'pinia'
import { useSnackbarStore } from '@/modules/global/stores/SnackbarStore'
import NSnackbar, { NSnackbarProps } from '@/modules/global/components/core/NSnackbar/NSnackbar.vue'
import { useAppStore } from '@/modules/global/stores/AppStore'

@Component({
  components: { NSnackbar },
  computed: {
    ...mapState(useAppStore, ['isInPrintMode']),
    ...mapState(useSnackbarStore, ['items'])
  }
})
export default class NSnackbarProvider extends Vue {
  private items!: Array<NSnackbarProps>
  private isInPrintMode!: boolean

  get showSnackbars() {
    return !this.isInPrintMode
  }

  private get topCenter() {
    return this.items.filter(
      item => item.anchorOrigin?.vertical === 'top' && item.anchorOrigin?.horizontal === 'center'
    )
  }

  private get topRight() {
    return this.items.filter(item => item.anchorOrigin?.vertical === 'top' && item.anchorOrigin?.horizontal === 'right')
  }

  private get topLeft() {
    return this.items.filter(item => item.anchorOrigin?.vertical === 'top' && item.anchorOrigin?.horizontal === 'left')
  }

  private get bottomCenter() {
    const items = this.items.filter(
      item => item.anchorOrigin?.vertical === 'bottom' && item.anchorOrigin?.horizontal === 'center'
    )
    return this.swapContactBanner(items)
  }

  private get bottomLeft() {
    return this.items.filter(
      item => item.anchorOrigin?.vertical === 'bottom' && item.anchorOrigin?.horizontal === 'left'
    )
  }

  private get bottomRight() {
    return this.items.filter(
      item => item.anchorOrigin?.vertical === 'bottom' && item.anchorOrigin?.horizontal === 'right'
    )
  }

  swapContactBanner(items: NSnackbarProps[]): NSnackbarProps[] {
    const lastItemIndex = items.length - 1
    const contactBannerIndex = items.findIndex(item => item.isContactBanner)
    if (contactBannerIndex !== -1) {
      ;[items[lastItemIndex], items[contactBannerIndex]] = [items[contactBannerIndex], items[lastItemIndex]]
    }
    return items
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.snackbar-provider {
  position: absolute;
  z-index: $notch-layer-snackbar;
}

article {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;

  .nsnackbar {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: $notch-space-3x;
    @include mobile {
      width: 95%;
    }
  }

  @include mobile {
    width: 100%;
  }
}

.top-left {
  top: $notch-space-10x;
  left: $notch-space-10x;

  @include mobile {
    left: 0;
  }
}

.top-right {
  top: $notch-space-10x;
  right: $notch-space-10x;

  @include mobile {
    right: 0;
  }
}

.top-center {
  top: $notch-space-10x;
  left: 50%;
  transform: translateX(-50%);
}

.bottom-left {
  bottom: $notch-space-10x;
  left: $notch-space-10x;

  @include mobile {
    left: 0;
  }
}

.bottom-right {
  bottom: $notch-space-10x;
  right: $notch-space-10x;

  @include mobile {
    right: 0;
  }
}

.bottom-center {
  bottom: $notch-space-10x;
  left: 50%;
  transform: translateX(-50%);

  @include mobile {
    left: 0;
    transform: none;
  }
}

.fade-snackbar-enter-active,
.fade-snackbar-leave-active {
  transition: opacity 0.2s;
}
.fade-snackbar-enter,
.fade-snackbar-leave-to {
  opacity: 0;
}
</style>
